// src/pages/AuthPage.js
import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import LoginForm from '../components/auth/LoginForm';
import RegisterForm from '../components/auth/RegisterForm';
import './AuthPage.css';

function AuthPage() {
  const location = useLocation();
  const [isLoginMode, setIsLoginMode] = useState(true);
  const navigate = useNavigate();
  const { login, register, isAuthenticated } = useAuth();
  
  // Vérifier si l'utilisateur est déjà connecté
  useEffect(() => {
    if (isAuthenticated) {
      navigate('/dashboard');
    }
  }, [isAuthenticated, navigate]);
  
  // Vérifier si on doit afficher le formulaire d'inscription
  useEffect(() => {
    // Si on vient de la page d'accueil avec state.register=true, afficher le formulaire d'inscription
    if (location.state?.register) {
      setIsLoginMode(false);
    }
  }, [location]);
  
  const handleLogin = async (formData) => {
    try {
      console.log('AuthPage - handleLogin appelé avec:', formData);
      // Appel à la fonction login du contexte d'authentification
      const result = await login(formData.email, formData.password);
      console.log('AuthPage - résultat de connexion:', result);
      
      if (result.success) {
        console.log('AuthPage - connexion réussie, redirection vers /dashboard');
        navigate('/dashboard');
      }
      return result;
    } catch (error) {
      console.error('AuthPage - erreur de connexion:', error);
      return { success: false, error: error.message || 'Erreur de connexion' };
    }
  };
  
  const handleRegister = async (formData) => {
    try {
      const result = await register(formData);
      if (result.success) {
        navigate('/dashboard');
      }
      return result;
    } catch (error) {
      return { success: false, error: error.message || 'Erreur d\'inscription' };
    }
  };
  
  const switchToLogin = () => {
    setIsLoginMode(true);
  };
  
  const switchToRegister = () => {
    setIsLoginMode(false);
  };
  
  return (
    <div className="auth-page">
      <a href="https://www.automotive-database.com/" className="auth-logo-link">
        <img
          src="/images2/Logos AWD/Horizontal/Colored_no_background.png"
          alt="Automotive Database"
          className="auth-logo"
        />
      </a>

      <div className="auth-container">
        <div className="auth-branding">
          <div className="logo-large">Automotive Database</div>
          <h1>Your personalized automotive database</h1>
          <p>
            Accédez à une collection riche d'articles, brevets et publications
            sur l'innovation automobile.
          </p>

          <div className="auth-features">
            <div className="feature">
              <div className="feature-icon">🔍</div>
              <div className="feature-text">Recherche avancée</div>
            </div>
            <div className="feature">
              <div className="feature-icon">⚡</div>
              <div className="feature-text">Filtrage rapide</div>
            </div>
            <div className="feature">
              <div className="feature-icon">📊</div>
              <div className="feature-text">Organisation intuitive</div>
            </div>
            <div className="feature">
              <div className="feature-icon">🔒</div>
              <div className="feature-text">Accès sécurisé</div>
            </div>
          </div>
        </div>

        <div className="auth-forms">
          {isLoginMode ? (
            <LoginForm
              onLogin={handleLogin}
              onSwitchToRegister={switchToRegister}
            />
          ) : (
            <RegisterForm
              onRegister={handleRegister}
              onSwitchToLogin={switchToLogin}
            />
          )}
        </div>
      </div>
    </div>
  );
}

export default AuthPage;